import { postWithToken } from "../authentication/AuthProvider";
import config from "../config";

export const leed_category_routes = (leed_category) => ({
  label: "Leed Category",
  root: leed_category,
  get_all: leed_category + "/get_all",
});
